export default function refreshIndex(index) {
  const winWidth = window.innerWidth < 1400 ? 1400 : window.innerWidth;
  let totalWidth = 0;
  let width;
  let x;
  let subWidth;
  let totalSubWidth;
  let subItem;
  let subBlocks = [];
  return index.map(item => {
    if (item.unit === '%') {
      width = parseInt((item.width / 100) * winWidth, 10);
    } else {
      width = parseInt(item.width, 10);
    }
    subWidth = 0;
    totalSubWidth = 0;
    subBlocks = [];
    if (item.subBlocks) {
      item.subBlocks.forEach(sub => {
        subItem = { ...sub };
        if (item.unit === '%') {
          subWidth = parseInt((sub.width / 100) * winWidth, 10);
        } else {
          subWidth = parseInt(sub.width, 10);
        }
        subItem.width = subWidth;
        subItem.unit = 'px';
        subItem.x = totalWidth + width + totalSubWidth;
        // subItem
        totalSubWidth += subWidth;
        subBlocks.push(subItem);
      });
    }
    x = totalWidth;
    totalWidth += width + totalSubWidth;
    return {
      ...item,
      subBlocks,
      x,
      width,
      unit: 'px',
    };
  });
}
